import React, { useCallback } from "react";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import { Formik } from "formik";
import * as Yup from "yup";
import { useToasts } from "react-toast-notifications";
import { useDispatch } from "react-redux";
import initialValues from "./initialValues";
import { sendUserInfo } from "../../redux/actions/subscriptionActions";
const DownloadPopup = ({ open,onClose }) => {
  const dispatch = useDispatch();
  const { addToast } = useToasts();

  const onSubmit = useCallback(
    (values) => {
      
    dispatch(sendUserInfo(values, addToast));
    onClose()
    },
    [addToast, dispatch]
  );
  return (
    <>
      <style>
        {`
.popup-content {
    
  width: 30%!important;
  
}
    @media only screen and (max-width: 767px){
      .popup-content {
      width: 90% !important;
      }
    }
`}
      </style>
      <Popup open={open} onClose={onClose} position="right center">
        {(close) => (
          <div>
            <a className="close" onClick={close}>
              &times;
            </a>
            <div className="form-container" style={{ width: "auto" }}>
              <Formik
                initialValues={initialValues}
                validationSchema={Yup.object().shape({
                  name: Yup.string().required(),
                  email: Yup.string().required(),
                  state: Yup.string().required(),
                })}
                onSubmit={onSubmit}
              >
                {({ handleChange, handleSubmit, errors, isSubmitting }) => (
                  <form onSubmit={handleSubmit} style={{ padding: "2rem" }}>
                    <div className="column">
                      <div>
                        <div className="d-flex flex-row justify-content-center">
                          <img
                            src="/assets/img/logo/logo-subs.svg"
                            style={{ width: "5rem", marginBottom: "2rem" }}
                          />
                        </div>
                        <h4 style={{ textAlign: "center" }}>
                          ¡Déjanos tus datos y te enviaremos por mail el link de descarga!
                        </h4>
                        <div className="column">
                          <div>
                            <div className="mb-20">
                              <label>Nombre</label>
                              <input
                                type="text"
                                required
                                error={errors.name}
                                name="name"
                                onChange={handleChange}
                              />
                            </div>
                          </div>
                          <div>
                            <div className="billing-info mb-20">
                              <label>Ciudad / Departamento</label>
                              <input
                                type="text"
                                required
                                error={errors.state}
                                name="state"
                                onChange={handleChange}
                              />
                            </div>
                          </div>

                          <div>
                            <div className="mb-20">
                              <label>Email</label>
                              <input
                                type="text"
                                required
                                error={errors.email}
                                name="email"
                                onChange={handleChange}
                              />
                            </div>
                          </div>
                          <div className="place-order">
                            <button
                              disabled={isSubmitting}
                              type="submit"
                              className="btn-hover"
                            >
                              Enviar
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                )}
              </Formik>
            </div>
          </div>
        )}
      </Popup>
    </>
  );
};

export default DownloadPopup;